import React, { useState } from 'react';

import ServerMonitorDashboard from "./components/ServerMonitorDashboard";
import SciFiLogin from "./components/SciFiLogin";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    return (
        <div className="App">
            {isAuthenticated ? (
                <ServerMonitorDashboard onLogout={() => setIsAuthenticated(false)} />
            ) : (
                <SciFiLogin onLoginSuccess={() => setIsAuthenticated(true)} />
            )}
        </div>
    );
}

export default App;
